import { TextButton } from "Components/Button";
import { useState } from "react";

// HL7 Modal definition row
function HL7ModalDef({ defKey, value, shortValue }) {
    
    // If short value or regular value is displayed
    const [expanded, setExpanded] = useState(false);
    
    return (
        <div className="definition-container p-4 d-flex flex-column flex-md-row gap-8px gap-md-40px">
            {/* Term */}
            <div className="definition-key">
                {defKey}
            </div>

            {/* Mobile - Definition */}
            <div className={"definition-value d-block d-md-none"}>
                <span>
                    {
                        expanded==true
                        ?   value 
                        :   shortValue != null 
                            ?   shortValue
                            :   value
                    }
                </span> 

                {/* Add space */}
                <span> </span>

                {
                    // If a short value is provided, allow toggle long value
                    shortValue != null
                    ?
                        <TextButton 
                            variant="link"
                            onClick={()=>{
                                setExpanded(!expanded);
                            }}
                            content={expanded==false ? 'See More...' : "See Less"}
                        ></TextButton>
                    :   null
                }
            </div>

            {/* Desktop - Definition */}
            <div className={"definition-value d-none d-md-block"}>
                {value}
            </div>
        </div>
    );
}

export default HL7ModalDef;